<template>
  <Sheet :open="open" @update:open="handleSheetOpenClose">
    <SheetTrigger v-if="$slots.trigger" :disabled="disabled" asChild>
      <slot name="trigger" />
    </SheetTrigger>
    <SheetContent :class="cn(contentVariants({ variant }), props.class)">
      <SheetHeader :class="{ '!p-0': !title && !description }">
        <div v-if="$slots['header-start']">
          <slot name="header-start" />
        </div>
        <SheetTitle
          :class="
            cn(titleVariants({ variant: headerVariant || variant }), {
              hidden: !title,
            })
          "
        >
          {{ title }}
        </SheetTitle>
        <SheetDescription
          :class="
            cn(descriptionVariants({ variant: headerVariant || variant }), {
              hidden: !description,
            })
          "
        >
          {{ description }}
        </SheetDescription>
        <div v-if="$slots['header-end']">
          <slot name="header-end" />
        </div>
      </SheetHeader>
      <slot name="content" />
      <SheetFooter v-if="$slots.footer" id="footer" class="flex grow-0">
        <slot name="footer" />
      </SheetFooter>
    </SheetContent>
  </Sheet>
</template>

<script setup>
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/Shadcn/Components/ui/sheet";
import { cn } from "@/Utils/cn";
import { contentVariants, titleVariants, descriptionVariants } from ".";

const emit = defineEmits(["open", "close"]);

const props = defineProps({
  variant: { type: null, required: false },
  headerVariant: { type: null, required: false },
  open: { type: Boolean, default: undefined },
  title: { type: String, required: false },
  description: { type: String, required: false },
  class: { type: null, required: false },
  disabled: { type: Boolean, default: false },
});

function handleSheetOpenClose(isSheetOpening) {
  if (isSheetOpening) {
    emit("open");
    return;
  }

  emit("close");
}
</script>
